// Ícone oficial do YouTube (versão branca monocromática por padrão, ou vermelha) — exigência das diretrizes de marca
// da API do YouTube: manter forma e cores originais e nunca usar com menos de 20px de altura.
// https://developers.google.com/youtube/terms/branding-guidelines
export const YT_MIN_HEIGHT = 20;
// Variante padrão do app: branca (fundo escuro). Use variant="red" para a versão colorida.
export const YT_DEFAULT_VARIANT = "white";
const YT_SHAPE = "M27.4 3.1A3.5 3.5 0 0 0 24.9.6C22.7 0 14 0 14 0S5.3 0 3.1.6A3.5 3.5 0 0 0 .6 3.1C0 5.3 0 10 0 10s0 4.7.6 6.9a3.5 3.5 0 0 0 2.5 2.5C5.3 20 14 20 14 20s8.7 0 10.9-.6a3.5 3.5 0 0 0 2.5-2.5c.6-2.2.6-6.9.6-6.9s0-4.7-.6-6.9z";
const YT_PLAY = "M11.2 14.3 18.5 10l-7.3-4.3v8.6z";

export function YouTubeIcon({ height = YT_MIN_HEIGHT, variant = YT_DEFAULT_VARIANT, className = "", title = "YouTube", style, ...rest }) {
  const h = Math.max(YT_MIN_HEIGHT, height);
  // style inline: vence regras como "[&_svg]:size-4" dos botões, que encolheriam o ícone abaixo de 20px.
  return (
    <svg viewBox="0 0 28 20" height={h} width={(h * 28) / 20} className={`inline-block flex-shrink-0 ${className}`}
      style={{ height: h, width: (h * 28) / 20, minHeight: h, ...style }} role="img" aria-label={title} {...rest}>
      {variant === "white" ? (
        // Versão monocromática branca (permitida pelas diretrizes em fundos escuros): o "play" é vazado.
        <path fill="#FFFFFF" fillRule="evenodd" d={`${YT_SHAPE} ${YT_PLAY}`} />
      ) : (
        <>
          <path fill="#FF0000" d={YT_SHAPE} />
          <path fill="#FFFFFF" d={YT_PLAY} />
        </>
      )}
    </svg>
  );
}

/** Para mapas de ícones que recebem className: mantém só as margens; tamanho e cor são sempre os oficiais. */
export function YouTubeBrandIcon({ className = "" }) {
  const margins = className.split(/\s+/).filter((c) => /^-?m[trblxy]?-/.test(c)).join(" ");
  return <YouTubeIcon className={margins} />;
}

export default YouTubeIcon;
